import React from 'react';

const ErrorPage = () => {
  return <div>
    <h1>This is an ERROR page!</h1>
  </div>;
};

export default ErrorPage;
